import React from 'react';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  root: {
    '& .CalendarSync__title': {
      display: 'none'
    },
    '& p': {
      marginBottom: 10
    }
  }
};

class Connect extends React.Component {
  componentDidMount() {
    const scheduler = window.CronofyElements.CalendarSync({
      target_id: "cronofy-element-sync",
      authorization: {
        redirect_uri: process.env.REACT_APP_URL + "/calendar",
        client_id: process.env.REACT_APP_CRONOFY_CLIENT_ID,
        scope: "read_write"
      },
      single_profile: true,
      styles: {
        prefix: "CalendarSync"
      },
      callback: (e) => {
        console.log(e);
      },
    });

    this.scheduler = scheduler
    this.scheduler.refresh()
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return false;
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <div id="cronofy-element-sync" />
      </div>
    )
  }
}

export default withStyles(styles)(Connect);
